import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AppSettings } from "src/config/config";
import { apiConstants } from "../constant/apiConstant";
import { Injectable } from "@angular/core";



@Injectable()
export class NewSchoolRegistrationServices{
    private url= AppSettings.API_ENDPOINT_V3;
    private getDomainSuggestion = apiConstants.getSchoolDomain;
    private verifyDomain =apiConstants.verifySchoolDomain;
    private schoolRegister= apiConstants.schoolRegistration;
    private otpVerification= apiConstants.verifyOtp;
    headers: HttpHeaders;

    constructor(private http : HttpClient){}

    schoolDomainSuggestion(name, partnerDomain) {
        return this.http.get(`${this.url}${this.getDomainSuggestion}/?instituteName=${name}&lang=en&partnerDomain=${partnerDomain}`,
            { headers: this.headers }).pipe(map(res => res));
    }

    schoolDomainVerification(name) {
        return this.http.get(`${this.url}${this.verifyDomain}/?schoolDomain=${name}&lang=en`,
            { headers: this.headers }).pipe(map(res => res));
    }

    schoolRegistrationApi(body){
        return this.http.post(`${this.url}${this.schoolRegister}`,body ,{ headers: this.headers }).pipe(map(res => res))
    } 
    
    otpVerificationApi(body){
        return this.http.post(`${this.url}${this.otpVerification}`,body ,{ headers: this.headers }).pipe(map(res => res))
    }

    
}